export function toNumber(value: string | number): number {
  const type = typeof value
  if (type !== 'string' && type !== 'number') throw `Cannot parse value of type ${type} to 'number'`
  if (value && type === 'string' && !Number.isNaN(parseFloat(value as string))) return parseFloat(value as string)
  return value as number
}
